import { render } from "./Service.vue?vue&type=template&id=fc88d5b2&scoped=true"
const script = {}

import "./Service.vue?vue&type=style&index=0&id=fc88d5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc88d5b2"]])

export default __exports__